import React from "react";
import styles from "./ArchiveHeader.module.scss";

type Props = {
  title: string;
  perView: number;
  handlePerView: (value: number) => void;
  searchComponent?: React.ReactNode;
};

const ArchiveTitle: React.FC<Props> = ({
  title,
  perView,
  handlePerView,
  searchComponent,
}) => {
  return (
    <div className={styles["header"]}>
      <h2 className={styles["title"]}>{title}</h2>
      {searchComponent ? searchComponent : null}

      <div className={`${styles["select"]} ${styles["search-count"]}`}>
        <span>表示件数：</span>
        <select
          value={perView}
          onChange={(e) => {
            handlePerView(parseInt(e.target.value));
          }}
        >
          <option value={12}>12件</option>
          <option value={24}>24件</option>
          <option value={60}>60件</option>
        </select>
      </div>
    </div>
  );
};

export default ArchiveTitle;
